<template>
    <div style="z-index: 11">
        <v-menu min-width="250" offset-y v-model="menuOpen" :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
                <v-btn depressed fab v-bind="attrs" v-on="on" class="" :disabled="disabled">
                    <v-avatar v-bind="attrs" v-on="on" size="55" color="#dbe2e8">
                        <v-img v-if="profileUrl" :src="profileUrl" @error="$emit('profile-error')"></v-img>
                        <font-awesome-icon v-else icon="fa-solid fa-user"></font-awesome-icon>
                    </v-avatar>
                </v-btn>
            </template>
            <v-card>
                <v-list dense class="profile-menu">
                    <v-list-item>
                        <v-list-item-title>
                            <h5>
                                {{ profileName }}
                            </h5>
                        </v-list-item-title>
                    </v-list-item>
                    <template v-if="state.isMobile">
                        <v-divider class="my-1"></v-divider>
                        <ShareMenu mode="list-item"> </ShareMenu>
                    </template>
                    <template v-if="!state.isContributor">
                        <v-divider class="my-1"></v-divider>

                        <v-list-item @click="$refs.scanningModal.open()" v-if="tributeVideo?.deeplink">
                            <font-awesome-icon
                                style="color: #9ca3af"
                                class="mr-2"
                                icon="fa-solid fa-film-cannister"
                            ></font-awesome-icon>
                            <span style="color: #374151">Scan printed photos</span>
                        </v-list-item>
                        <!-- <v-list-item v-if="tributeVideo?.id" @click="initProfileUpdate">
                            <font-awesome-icon
                                style="color: #9ca3af"
                                class="mr-2"
                                icon="fa-solid fa-rotate"
                            ></font-awesome-icon>
                            <span style="color: #374151">Change Image</span>
                        </v-list-item> -->
                        <!-- <v-list-item v-if="mainPhotoId" @click="$refs.editModal.open()">
                            <font-awesome-icon
                                style="color: #9ca3af"
                                class="mr-2"
                                icon="fa-regular fa-pencil"
                            ></font-awesome-icon>
                            <span style="color: #374151">Edit Image</span>
                        </v-list-item> -->
                        <!-- <v-list-item
                            :disabled="!mainPhotoId"
                            class="danger"
                            @click="openProfileRemoveConfirmationModal"
                            v-if="!state.isContributor && mainPhotoId"
                        >
                            <font-awesome-icon
                                class="mr-2"
                                icon="fa-regular fa-trash-can"
                                style="color: #ef4444"
                            ></font-awesome-icon>
                            <span style="color: #b91c1c">Remove Image</span>
                        </v-list-item> -->
                        <v-list-item
                            v-if="!state.isFamily && !state.isContributor && tributeVideo?.id"
                            class=""
                            @click="openSettingsModal"
                        >
                            <font-awesome-icon
                                class="mr-2"
                                icon="fa-regular fa-cog"
                                style="color: #9ca3af"
                            ></font-awesome-icon>
                            <span style="color: #374151">Settings</span>
                        </v-list-item>

                        <v-list-item
                            v-if="!state.isFamily && !state.isContributor"
                            @click="openTab(`/tribute-slideshow/${$route.params.slug}`)"
                        >
                            <font-awesome-icon
                                class="mr-2"
                                icon="fa-regular fa-images"
                                style="color: #9ca3af"
                            ></font-awesome-icon>
                            <span style="color: #374151">View Slideshow</span>
                        </v-list-item>
                    </template>
                    <v-divider v-if="!state.isFamily && !state.isContributor" class="my-1"></v-divider>

                    <v-list-item
                        v-if="!state.isFamily && !state.isContributor"
                        @click="$router.push(`/services/${$route.params.slug}`)"
                    >
                        <img :src="require(`@/assets/images/icon_dark.png`)" alt="logo" class="ms-icon" />
                        <span style="color: #374151">Back to MemoryShare</span>
                    </v-list-item>
                </v-list>
            </v-card>
        </v-menu>

        <SlideUpload
            ref="menuProfileUploader"
            @filesAdded="file => handleUpdateProfileImage(file)"
            @progress="val => handleProgress(val)"
            :maxFiles="1"
            :videoAllowed="false"
            :disabled="disableProfileUpdate"
            hidden
        />
        <PhotoEditorModal
            v-if="mainPhotoId && state.token && tributeVideo.eventId"
            ref="editModal"
            :mainPhotoId="mainPhotoId"
            :token="state.token"
            :isMobile="state.isMobile"
            :eventId="tributeVideo.eventId"
        />
        <TributeEditorSettingsModal v-if="state.token" ref="settingsModal" :token="state.token" />
        <ScanningAppModal v-if="state.token && tributeVideo && tributeVideo.deeplink" ref="scanningModal" />

        <v-dialog v-model="profileRemoveConfirmationModal" max-width="400px">
            <v-card>
                <v-card-title>Remove Profile Photo</v-card-title>
                <v-card-text>Are you sure you want to remove the profile image?</v-card-text>
                <v-card-actions class="d-flex justify-space-between">
                    <v-btn depressed @click="profileRemoveConfirmationModal = false">Close</v-btn>
                    <v-btn :disabled="!mainPhotoId" @click="deleteProfilePhoto" color="error" depressed>Confirm</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import initApiServices from '@/services/ApiInitializer';
import { mapActions } from 'vuex';
import SlideUpload from '@/components/Tribute/SlideUpload.vue';
import ShareMenu from './ShareMenu.vue';
import PhotoEditorModal from '../Modals/PhotoEditorModal.vue';
import TributeEditorSettingsModal from '../Modals/TributeEditorSettingsModal.vue';
import ScanningAppModal from '../Modals/ScanningAppModal.vue';
export default {
    data() {
        return {
            menuOpen: false,
            apiService: null,
            showSettingsModal: false,
            showScanAppModal: false,
            profileRemoveConfirmationModal: false,
        };
    },
    inject: ['state'],
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
    },

    components: { SlideUpload, ShareMenu, PhotoEditorModal, TributeEditorSettingsModal, ScanningAppModal },
    computed: {
        profileName() {
            return `${this.$store.state.tributeVideo.firstName} ${this.$store.state.tributeVideo.lastName}`;
        },
        profileUrl() {
            return this.$store.state.tributeVideo.mainPhotoUrl;
        },
        mainPhotoId() {
            return this.$store.state.tributeVideo.mainPhotoId;
        },
        contributorDetailsSet() {
            return this.$store.state.tributeVideo.contributorDetailsSet;
        },
        disableProfileUpdate() {
            return this.state.isContributor || (this.state.isFamily && !this.contributorDetailsSet);
        },
        tributeVideo() {
            return this.$store.state.tributeVideo;
        },
        profileUploadProgress() {
            return this.$store.state.tributeVideo.profileUploadProgress;
        },
        showProfileUploadProgress() {
            return this.$store.state.tributeVideo.showProfileUploadProgress;
        },
    },
    methods: {
        ...mapActions(['showSnackbar']),
        ...mapActions('tributeVideo', [
            'updateProfileUploadProgress',
            'updateShowProfileUploadProgress',
            'updatePendingProfileUpload',
        ]),
        openTab(url) {
            window.open(url, '_blank');
        },
        moveToSetup() {
            this.$emit('change-step', 'setup');
            this.menuOpen = false;
        },
        handleProgress(val) {
            if (val > this.profileUploadProgress) {
                this.updateProfileUploadProgress(val);
            }
        },
        initProfileUpdate() {
            if (this.disableProfileUpdate) {
                if (this.state.isFamily && !this.contributorDetailsSet) {
                    this.showSnackbar({ message: 'Please set set your details to continue', color: 'error' });
                } else {
                    this.showSnackbar({ message: 'This action is currently unavailable', color: 'error' });
                }
            }

            this.moveToSetup();
            const uploader = this.$refs.menuProfileUploader;

            if (!uploader || typeof uploader.openFileSelection !== 'function') {
                throw new Error('Error initiating upload');
            }

            return uploader.openFileSelection();
        },
        async handleUpdateProfileImage(file) {
            try {
                this.updateShowProfileUploadProgress(true);

                this.updatePendingProfileUpload(file);

                const uploadResp = await this.uploadPhoto(this.tributeVideo.eventId);
                this.updatePendingProfileUpload(null);

                if (uploadResp.data.length === 0) {
                    this.showSnackbar({ message: 'Error updating profile', color: 'error' });
                    return;
                }

                this.$store.dispatch('tributeVideo/updateTributeVideo', {
                    ...this.tributeVideo,
                    mainPhotoUrl: uploadResp.data[0].url,
                    mainPhotoId: uploadResp.data[0].id,
                });

                this.showSnackbar({ message: 'Profile picture updated' });
            } catch {
                console.log(error, 'error');
            } finally {
                this.updateProfileUploadProgress(0);
                this.updateShowProfileUploadProgress(false);
            }
        },
        uploadPhoto(eventId) {
            if (!eventId || eventId <= 0) {
                throw new Error('Invalid event id');
            }

            const uploader = this.$refs.menuProfileUploader;

            if (!uploader || typeof uploader.initUpload !== 'function') {
                throw new Error('Error initiating upload');
            }

            //For Profile Image, replaceMain must be set to true;
            return uploader.initUpload(eventId, true);
        },
        openProfileRemoveConfirmationModal() {
            this.profileRemoveConfirmationModal = true;
        },
        // confirmAction(action, callback) {
        //     let confirmMessage = 'Are you sure?';
        //     let button = {
        //         text: 'Confirm',
        //         color:'red',
        //         callback: callback
        //     }
        //     switch (action) {
        //         case 'removeImage':
        //             confirmMessage = 'Are you sure you want to remove the profile image?';
        //         break;
        //     }
        //     this.showSnackbar({ message: confirmMessage, button });
        // },
        async deleteProfilePhoto() {
            this.profileRemoveConfirmationModal = false;
            const photoId = this.mainPhotoId;
            this.menuOpen = false;

            if (!photoId) {
                this.showSnackbar({ message: 'Error deleting profile photo', color: 'error' });
                return;
            }

            this.$store.dispatch('tributeVideo/updateTributeVideo', {
                ...this.tributeVideo,
                mainPhotoId: 0,
                mainPhotoUrl: null,
            });

            try {
                await this.apiService.tributePhoto.deletePhoto(photoId);
                this.showSnackbar({ message: 'Profile picture deleted' });
            } catch (error) {
                console.log(error, 'error deleting  profile photo');
            }
        },
        async setAuthToken() {
            const response = await this.$auth.getIdTokenClaims();
            this.token = response.__raw;
        },
        openSettingsModal() {
            if (this.$refs.settingsModal) {
                this.$refs.settingsModal.open();
            } else {
                // If settingsModal isn't available yet we'll attempt again on an interval
                const refWatcher = setInterval(() => {
                    if (this.$refs.settingsModal) {
                        clearInterval(refWatcher);
                        this.$refs.settingsModal.open();
                    }
                }, 250);
            }
        },
    },
    async mounted() {
        if (this.state.token) {
            this.token = this.state.token;
        } else {
            await this.setAuthToken();
        }
        this.apiService = initApiServices(this.token);

        this.$root.$on('tribute:open-settings-modal', () => {
            this.openSettingsModal();
        });
    },
};
</script>
<style lang="scss" scoped>
.profile-menu {
    // min-width: 500px;
}

.v-list-item {
    &.v-list-item--disabled {
        opacity: 0.6;
    }
}
.ms-icon {
    width: 18px;
    margin-left: -2px;
    margin-right: 6px;
    filter: contrast(0.1);
}
</style>
